//Name list from https://www.randomlists.com/random-first-names?dup=false&qty=100

export const NameList = [
	'Abby',
	'Ace',
	'Ahmed',
	'Alessandra',
	'Allyson',
	'Alyssa',
	'Amiya',
	'Ariel',
	'Ashanti',
	'Ashtyn',
	'Atticus',
	'Austin',
	'Braden',
	'Braeden',
	'Cameron',
	'Cesar',
	'Charlize',
	'Clarissa',
	'Cortez',
	'Crystal',
	'Damaris',
	'Dane',
	'Danielle',
	'Deangelo',
	'Denise',
	'Dereon',
	'Deven',
	'Dillon',
	'Elliott',
	'Emmett',
	'Esteban',
	'Everett',
	'Fiona',
	'Frances',
	'Gabriela',
	'Gage',
	'Gavyn',
	'Gianni',
	'Haiden',
	'Harrison',
	'Helen',
	'Ibrahim',
	'Ingrid',
	'Irvin',
	'Janiya',
	'Jaquan',
	'Jared',
	'Jason',
	'Jayla',
	'Jayleen',
	'Jaylynn',
	'Jerimiah',
	'Jerome',
	'Joanna',
	'Josh',
	'Julianna',
	'Kade',
	'Kareem',
	'Kasen',
	'Keon',
	'Kylan',
	'Lana',
	'Lea',
	'Leslie',
	'Lincoln',
	'Linda',
	'Lorelai',
	'Lorena',
	'Lucy',
	'Madyson',
	'Maleah',
	'Margaret',
	'Marianna',
	'Maverick',
	'Mohammad',
	'Morgan',
	'Nataly',
	'Noel',
	'Parker',
	'Patricia',
	'Phillip',
	'Reynaldo',
	'Roselyn',
	'Ryleigh',
	'Saige',
	'Sanaa',
	'Savannah',
	'Shannon',
	'Siena',
	'Skyla',
	'Sofia',
	'Tia',
	'Tommy',
	'Violet',
	'Winston',
	'Zachary',
	'Zaid',
	'Zaiden',
	'Zariah',
];
